<template>
  <div class="app-container">

    <div class="filter-container">
      <div style="display:flex;justify-content:flex-end;align-items:center;width:100%;">
         <el-input
        v-model="listQuery.invitation_code"
        placeholder="编号"
        style="width: 200px;"
        class="filter-item"
        size="small"
        clearable
      />
        <el-input
        v-model="listQuery.name_phone"
        placeholder="用户昵称或手机号"
        style="width: 200px;"
        class="filter-item"
        size="small"
        clearable
      />
      <el-select
        v-model="listQuery.user_type"
        placeholder="会员"
        style="width: 120px"
        class="filter-item"
        size="small"
        clearable
      >
        <el-option label="非会员" :value="1" />
        <el-option label="普通会员" :value="2" />
        <el-option label="金牌代理" :value="3" />
        <el-option label="银牌代理" :value="4" />
      </el-select>


      <el-select
        v-model="listQuery.is_normal"
        placeholder="状态"
        style="width: 90px"
        class="filter-item"
        size="small"
        clearable
      >
        <el-option label="正常" :value="1" />
        <el-option label="冻结" :value="0" />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        size="small"
        @click="handleFilter"
        >搜索</el-button>
      </div>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="ID" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index }} -->
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column align="center" label="编号" width="95">
        <template slot-scope="scope">
          {{ scope.row.invitation_code }}
        </template>
      </el-table-column>

      <el-table-column label="头像" min-width="60" align="center">
        <template slot-scope="scope">
          <!-- <img :src="scope.row.avatar" class="user-avatar" /> -->
           <el-avatar :src="scope.row.avatar"></el-avatar>
        </template>
      </el-table-column>
      <el-table-column label="昵称" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.nickname }}
        </template>
      </el-table-column>

      <el-table-column label="是否会员" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag  v-if="scope.row.is_member === 0"  type="info">未开通</el-tag>
          <el-tag v-else-if="scope.row.is_agent === 1"  type="warning" >金牌会员</el-tag>
          <el-tag v-else-if="scope.row.is_agent === 2 && scope.row.is_member === 1"  type="success" >银牌会员</el-tag>
          <el-tag v-else-if="scope.row.is_member === 1" type="primary">{{scope.row.member_name}}</el-tag>
          <span v-else>后端无字段</span>
        </template>
      </el-table-column>

      <el-table-column label="会员到期时间" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.is_agent === 1">永久</span>
          <span v-else-if="scope.row.member_end_date">{{scope.row.member_end_date}}</span>
          <span v-else></span>
        </template>
      </el-table-column>

      <el-table-column label="余额" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.wallet.balance?scope.row.wallet.balance:0.00 }} 
        </template>
      </el-table-column>

    <el-table-column label="能量" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.chat_count }} 
        </template>
      </el-table-column>

      <el-table-column label="绘画次数" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.creative_num }} 
        </template>
      </el-table-column>

      <el-table-column label="文档次数" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.markdown_num }} 
        </template>
      </el-table-column>

      <el-table-column label="口语次数" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.english_chat_num }} 
        </template>
      </el-table-column>

      <el-table-column label="中文阅读次数" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.ai_chinese_num }} 
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="用户状态" min-width="60" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_normal === 1" type="primary">正常</el-tag>
          <el-tag v-else-if="scope.row.is_normal === 0" type="warning">冻结</el-tag>
          <el-tag v-else>后端无字段</el-tag>
        </template>
      </el-table-column>

      <el-table-column align="center" prop="created_at" label="最近登录时间" min-width="200">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.last_login_at | formatDate}}</span>
        </template>
      </el-table-column>

      
      <el-table-column align="center" prop="created_at" label="注册时间" min-width="200">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
    
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger"
      };
      return statusMap[status];
    }
    ,formatDate: function(value) {
      var date = new Date(value * 1000); // 将时间戳转换为毫秒
      return date.toLocaleString(); // 返回本地化的日期和时间字符串
    }
  },

  data() {
    return {
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        name_phone: '',
        is_normal: "",
        user_type: "",
        parent_id:''
      },
      from:
      {
        user_id:"",
        name:""
      },
      dialogVisible : false,
      inputValue: 2,
      MembersopenName : ""
    };
  },
  created() {
    this.listQuery.parent_id = this.$route.query.parent_id
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/associate/user/index",
        method: "get",
        params: this.listQuery
      }).then(response => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleForbid(val, text) {
      this.$confirm("此操作将" + text + "该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        showCancelButton: true, // 显示取消按钮
        center: true // 对话框内容居中显示
      })
        .then(() => {
          request({
            url: "/api/backend/user/is_normal",
            method: "post",
            params: { id: val }
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    handleAgent(val, text ,type ,inputValue) {
      this.$confirm("此操作将用户" + text + " 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        // showCancelButton: true, // 显示取消按钮
        center: true // 对话框内容居中显示
      })
        .then(() => {
          console.log(val, text ,type ,inputValue);
          request({
            url: "/api/backend/user/is_agent",
            method: "post",
            params: { 
              user_id: val ,
              type : type ,
              month: inputValue
            }
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功!"
            });
            this.dialogVisible = false;
            this.MembersopenName = '';
            this.inputValue = 2;
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
    cancel() {
      this.dialogVisible = false;
      },
    Membersopen(data) {
      this.dialogVisible =true;
      this.from={
      user_id:data.id,
      name:data.nickname
    };
    
      },
    handleInput() {
          // 去除非数字字符
      this.inputValue = this.inputValue.replace(/\D/g, "");
    },
    //他的下级
    subordinate(parent_id)
    {
        this.$router.push({path:'/user/subordinate',query:{parent_id}});
      // this.$router.push('/find/index_two/?up_id=' + row.id +'&up_name=' + row.name)
    }


  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
